export default __webpack_public_path__ + "static/media/background.a4eed4e9.jpg";